import styled from 'styled-components';

/**
 * H3 for text
 */
export const StyledH3 = styled.h3`
  color: ${({ theme }) => theme.colors.warning};
`;
